import type * as THREE from 'three';
import type { ChamferFeatureDefinitionModel } from '../../../feature/definition/chamfer/ChamferFeatureDefinition';
import type { ChamferFeaturePrototype } from '../../../feature/prototype/chamfer/ChamferFeaturePrototype';
import { FeaturePreviewObject } from '../FeaturePreviewObject';

/**
 * 倒角预览体对象。
 */
export class ChamferPreviewObject extends FeaturePreviewObject<
    ChamferFeaturePrototype,
    ChamferFeatureDefinitionModel
> {
    /**
     * @param input 输入参数。
     */
    public constructor(input: {
        prototype: ChamferFeaturePrototype;
        draftDefinition: ChamferFeatureDefinitionModel;
        meshData: MeshData;
        geometry: THREE.BufferGeometry;
        material: THREE.Material | THREE.Material[];
    }) {
        super(input);
    }
}
